import axios from 'axios';
import KeycloakService from '../services/KeycloakService';

export const initAxios = async(OVERRIDE_URL?: string, requireAuth = true) => {
  if (requireAuth) {
    if (!KeycloakService.isLoggedIn()) {
      return null;
    }

    // Refresh the Keycloak token
    await KeycloakService.updateToken();
  }

  return axios.create({
    baseURL: OVERRIDE_URL ? OVERRIDE_URL : process.env.REACT_APP_API_URL,
    timeout: 300000,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...(requireAuth && KeycloakService.isLoggedIn() ?
        { Authorization: `Bearer ${KeycloakService.getToken()}` } :
        {}),
    },
  });
};
